
<div id="PayoutModal" class="ui modal" style="position:absolute;left:25%;bottom:50% !important;">

    <div class="content">
        <span style="font-weight:bold;font-size:18px">{{"WITHDRAW_REMAINING_BALANCE" | t}}: {{this.coreService.customerUser.Balance}} ? </span>
        <button class="circular ui icon button" style="float:right;position:relative;bottom:10px;background-color:white;border: 1px solid;" (click)="PayoutModal_Button_No()">
    <i class="remove link icon"></i>
</button>
    </div>
    <div class="content" style="text-align:center">
        <button class="ui big button terminalButton" (click)="PayoutModal_Button_Yes()" style="width:150px;"><span>{{"OK" | t}}</span></button> &nbsp;&nbsp;
        <button class="ui big  button terminalButton" (click)="PayoutModal_Button_No()" style="width:150px;"><span>{{"CANCEL" | t}}</span></button>
    </div>
</div>
